const BASE = ['datamapping'];

export const DATAMAPPING_QUERY_KEYS = {
  getTimezoneListKey: () => [...BASE, 'timezone_list'],
};
